SET_USER_ACCOUNT_CANCEL_CONFIRM_ANSWER